import {
  makeStyles,
  Stepper,
  StepLabel,
  Step,
  Button,
} from '@material-ui/core';
import React, {useContext, useEffect, useRef} from 'react';
import {ArrowBack} from '@material-ui/icons';
import BatchTriggerBasicInfo from './BasicInfo';
import AddTrigger from './AddAgencyClient';
import StepConnector from '@material-ui/core/StepConnector';
import {withStyles} from '@material-ui/core/styles';
import {useDispatch, useSelector} from 'react-redux';
import useUnsavedChangesWarning from '../../../../util/CustomHooks';
import {setAlertData} from '../../../../redux/reducers/UnsavedChangesAlertReducer';
import Scheduler from '../../Reports/AddReport/StepperComponents/Scheduler';
import {ThemeContext} from '../../../../themes/ThemeProvider';
import {backButtonText} from '../../../../util/Content';
// import { postPrintScheduler } from "../../../../../redux/reducers/NightJobs/AddNightJob";
import NumberStepIcon from '../../../../components/customStepIcon';
import {
  resetTriggerGroupData
} from '../../../../redux/reducers/TriggerGroup';
const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  backButton: {
    marginRight: theme.spacing(1),
  },
  instructions: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  stepperIcon: {
    '& .MuiStepLabel-iconContainer': {
      '& .MuiStepIcon-root': {
        width: '35px !important',
        height: '35px !important',
      },
    },
    '& .MuiStepIcon-completed': {
      color: '#056c93',
    },
    '& .MuiStepIcon-active': {
      color: '#056c93',
    },
    '& .MuiStepLabel-labelContainer': {
      '& .MuiTypography-root': {
        fontSize: '1rem',
        fontWeight: 'bold',
      },
    },
  },
}));
const QontoConnector = withStyles({
  alternativeLabel: {
    top: 10,
    left: 'calc(-50% + 16px)',
    right: 'calc(50% + 16px)',
  },
  active: {
    '& $line': {
      borderColor: '#056c93',
    },
  },
  completed: {
    '& $line': {
      borderColor: '#056c93',
    },
  },
  line: {
    borderColor: '#eaeaf0',
    borderTopWidth: 3,
    borderRadius: 1,
  },
})(StepConnector);
const AddBatchTrigger = ({setTabValue, value, handleTabChange, rowSelected}) => {
  const stepperClasses = useStyles();
  const dispatch = useDispatch();
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const steps = ['Basic Info', 'Add Organization', 'Scheduler'];
  const {
    triggerGroupData,
    isBatchTriggersDraft,
    lastStep,
  } = useSelector(({addTriggerGroup}) => addTriggerGroup);
  const [activeStep, setActiveStep] = React.useState(isBatchTriggersDraft === 'N' ? 0 : lastStep);
  const showAlertRef = useRef(false);
  const {routerPrompt, onDirty, onPristine} = useUnsavedChangesWarning();
  console.log({
    triggerGroupData,
    isBatchTriggersDraft,
    lastStep,
  },"sssssssssssssssssssss")
  // const { setGlobalFieldRow, setSaveTab, sample, setSample, saveTab, newTabValue, setNewTabValue } =
  //   useContext(SelectTabContextProvider);
  // const { jobDetailsData } = useSelector(({ addNightJob }) => addNightJob);
  // const handleNext = () => {
  //   setActiveStep((prevActiveStep) => prevActiveStep + 1);
  // };
  useEffect(()=>{
    return ()=>{
      dispatch(resetTriggerGroupData())
    }
  },[])
  const handleNext = (value) => {
    setActiveStep((prevActiveStep) => (value ? Number(value) + 1 : prevActiveStep + 1));
  };
  const changeDirty = useRef(true);
  const handleDirty = (dirty, isFixed) => {
    if (isFixed === 'fixed') {
      showAlertRef.current = dirty;
      changeDirty.current = false;
      if (dirty) {
        onDirty();
      } else {
        onPristine();
      }
    }
    if (isFixed === 'reset') {
      showAlertRef.current = false;
      changeDirty.current = true;
      onPristine();
    }
    if (changeDirty.current) {
      showAlertRef.current = dirty;
      if (dirty) {
        onDirty();
      } else {
        onPristine();
      }
    }
  };
  const alertProps = {
    showAlertRef,
    handleDirty,
  };
  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };
  const getStepContent = (stepIndex) => {
    switch (stepIndex) {
    case 0:
      return (
        < BatchTriggerBasicInfo
          handleBack={handleBack}
          // selected={selected}
          activeStep={activeStep}
          handleNext={handleNext}
          rowSelected={rowSelected}
          // setReportCodeData={setReportCodeData}
          // edit={edit}
          // handleTabChange={handleTabChange}
          // setSample={setSample}
          // setSaveTab={setSaveTab}
          // saveTab={saveTab}
          {...alertProps}
        />
      );
    case 1:
      return (
        <AddTrigger
          handleBack={handleBack}
          // selected={selected}
          activeStep={activeStep}
          handleNext={handleNext}
          rowSelected={rowSelected}
          // setReportCodeData={setReportCodeData}
          // handleTabChange={handleTabChange}
          // setSample={setSample}
          // setSaveTab={setSaveTab}
          // saveTab={saveTab}
          {...alertProps}
        />
      );
    case 2:
      return (
        <Scheduler
          // setSample={setSample}
          {...alertProps}
          // selected={selected}
          // setSaveTab={setSaveTab}
          // saveTab={saveTab}
          batchTriggers = {true}
          rowSelected={rowSelected}
          setTabValue={setTabValue}
          handleTabChange={handleTabChange}
          handleBack={handleBack}
          setValue={handleNext}
          // nightJobsScheduler={true}
        />
      );
    }
  };
  // const isCurrentStepperCompleted = jobDetailsData?.taskRequest?.length > 0;
  return (
    <div>
      {routerPrompt}
      <div className="button-table-spacing-mb justify-content-between new-standard-textfields">
        <Button
          variant="outlined"
          type="button"
          className={`search-btn ${classes.buttonRoot}`}
          onClick={() => {
            if (showAlertRef.current) {
              dispatch(
                setAlertData({
                  showAlert: showAlertRef.current,
                  alertCallback: () => {
                    setTabValue(0);
                  },
                }),
              );
            } else {
              setTabValue(0);
            }
          }}
        >
          <ArrowBack className="mr-2" />
          {backButtonText}
        </Button>
        {/* {jobDetailsData?.jobCode && (
          <Button
            type="button"
            variant="outlined"
            className={`search-btn ml-2 ${classes.buttonRoot}`}
            onClick={() => {
              dispatch(
                postPrintScheduler({
                  jobCode: jobDetailsData?.jobCode ? jobDetailsData.jobCode : "",
                  createdFor: jobDetailsData?.createdFor ? jobDetailsData?.createdFor : "",
                  isDraft: jobDetailsData?.isDraft?.key ? jobDetailsData?.isDraft?.key : "",
                  jobName: jobDetailsData?.jobName ? jobDetailsData?.jobName : "",
                  jobDescription: jobDetailsData?.jobDescription
                    ? jobDetailsData.jobDescription
                    : "",
                  jobStatus: jobDetailsData?.jobStatus ? jobDetailsData?.jobStatus : "",
                  nextRuntime: jobDetailsData?.nextRunTime
                    ? moment(jobDetailsData?.nextRunTime).format("MM/DD/YYYY hh:mm:ss")
                    : "",
                  lastRunTime: jobDetailsData?.lastRunTime
                    ? moment(jobDetailsData?.lastRunTime).format("MM/DD/YYYY hh:mm:ss")
                    : "",
                  createdBy: jobDetailsData?.createdBy?.userName
                    ? jobDetailsData?.createdBy?.userName
                    : "",
                  createdDate: jobDetailsData?.createdDate
                    ? moment(jobDetailsData?.createdDate).format("MM/DD/YYYY")
                    : "",
                  orderBy: "",
                  orderDirection: "",
                  limit: "",
                  page: "",
                  printIndividual: "Y",
                })
              );
            }}
          >
            Download Configuration
          </Button>
        )} */}
      </div>
      <div className={classes.root} style={{border: '1px solid #cfcfcf'}}>
        <Stepper activeStep={activeStep} connector={<QontoConnector />}>
          {steps.map((label, index) => (
            <Step
              key={label}
              completed={index < activeStep || isBatchTriggersDraft === 'N' || index <= triggerGroupData?.lastStep}
              onClick={() => {
                if (isBatchTriggersDraft === 'N' || index <= triggerGroupData?.lastStep) {
                  if (showAlertRef.current) {
                    dispatch(
                      setAlertData({
                        showAlert: showAlertRef.current,
                        alertCallback: () => {
                          setActiveStep(index);
                        },
                      }),
                    );
                  } else {
                    setActiveStep(index);
                  }
                }
              }}
              style={{cursor: 'pointer'}}
            >
              <StepLabel
                className={`${stepperClasses.stepperIcon} ${
                  activeStep === index ? 'completedStyle' : null
                }`}
                StepIconComponent={NumberStepIcon}
              >
                {label}
              </StepLabel>
            </Step>
          ))}
        </Stepper>
        <div>
          <div style={{padding: '12px'}}>
            {getStepContent(activeStep)}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddBatchTrigger;
